import React from "react";
import { FiMapPin } from "react-icons/fi";
import {
  PROGRAM_LAB_ADDRESS_FIELDS,
  PROGRAM_LAB_ADDRESS_PLACEHOLDERS,
} from "./programLabCheckoutConstants";

export default function ProgramLabCheckoutAddress({
  address,
  addressStateError = null,
  labNames,
  purpose,
  suggestions,
  onStreetChange,
  onSuggestion,
  onAddressChange,
}) {
  return (
    <div className="lcw-card program-lab-checkout__address">
      <div className="lcw-card-body">
        <h3 className="lcw-section-title lcw-section-title--icon">
          <FiMapPin aria-hidden="true" className="program-lab-checkout__address-icon" focusable="false" />
          <span>
            {labNames?.length
              ? `Address needed for ${labNames.join(", ")}`
              : "Patient address"}
          </span>
        </h3>
        <p className="lcw-section-sub program-lab-checkout__address-note">{purpose}</p>
        {addressStateError && (
          <div className="lcw-unavail" role="alert">
            {addressStateError}
          </div>
        )}
        <div className="program-lab-checkout__grid">
          {PROGRAM_LAB_ADDRESS_FIELDS.map(([key, label]) => (
            <label
              key={key}
              className={`program-lab-checkout__field program-lab-checkout__field--${key} program-lab-checkout__field--full-width`}
            >
              <span>{label}</span>
              {key === "street" ? (
                <div className="lcw-input-wrap">
                  <input
                    className="lcw-input"
                    value={address.street || ""}
                    autoComplete="street-address"
                    placeholder={PROGRAM_LAB_ADDRESS_PLACEHOLDERS.street}
                    onChange={(event) => onStreetChange(event.target.value)}
                    onBlur={() => setTimeout(() => onSuggestion(null), 150)}
                    required
                  />
                  {suggestions.length > 0 && (
                    <div className="lcw-suggestions">
                      {suggestions.map((suggestion, index) => (
                        <button
                          type="button"
                          key={`${suggestion.streetLine}-${index}`}
                          className="lcw-suggestion"
                          onMouseDown={() => onSuggestion(suggestion)}
                        >
                          {`${suggestion.streetLine || ""}${suggestion.secondary ? ` ${suggestion.secondary}` : ""}, ${suggestion.city || ""}, ${suggestion.state || ""} ${suggestion.zipcode || ""}`.trim()}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <input
                  className="lcw-input"
                  value={address[key] || ""}
                  maxLength={key === "state" ? 2 : undefined}
                  autoComplete={key === "zip" ? "postal-code" : `address-${key}`}
                  placeholder={PROGRAM_LAB_ADDRESS_PLACEHOLDERS[key] || ""}
                  onChange={(event) => onAddressChange(
                    key,
                    key === "state" ? event.target.value.toUpperCase() : event.target.value,
                  )}
                  required={key !== "apt"}
                />
              )}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}
